import { z } from 'zod';

export const GatewayHardwareMetricsSchema = z.object({
  cpu_memory: z.number(),
  cpu_utilization: z.number(),
  disk_used_pct: z.number(),
  gpu_memory: z.number(),
  gpu_utilization: z.number(),
});
